import BlogCtrbItemList from "./BlogCtrbItemList";
import BlogCtrbItemCreate from "./BlogCtrbItemCreate";
import BlogCtrbItemEdit from "./BlogCtrbItemEdit";

export default {
    list: BlogCtrbItemList,
    create: BlogCtrbItemCreate,
    edit: BlogCtrbItemEdit,
};
